export mascote from "./mascote.png";



// WEBPACK FOOTER //
// ./src/components/app/generic-error/images/index.js